import React, { useEffect, useState } from 'react'
import Rails from "@rails/ujs"
import { RouteComponentProps } from "react-router-dom";
import ReactPaginate from "react-paginate"
import Axios from 'axios'
import Select from 'react-select'
import * as i18n from "i18n-js"

import ListItem from './ListItem'
import Paging from '../Notifications/Paging'
import { TruckData, ISelectOption } from "../Common/types"
import { URLParamsReader } from "../Common/URLParamsReader"
import TextSearchField from '../Notifications/TextSearchField';

interface ListProps extends RouteComponentProps<any> {
  history: string[],
  location: { pathname: string, search: string }
}

//@ts-ignore
i18n.translations = I18n.translations || {};

const List = (props: ListProps) => {

  const urlParams = new URLParamsReader(props.location.search, "status=1,CLOSED:0,OPEN");

  const [settings, setSettings] = useState({
    sidx: urlParams.getSidx('created_at'),
    sord: urlParams.getSord(),
    rows: urlParams.getRows(),
    page: urlParams.getPage(),
    customer: urlParams.getISelect('customer'),
    manager: urlParams.getISelect('manager'),
    query: urlParams.getString('query'),
    consec: urlParams.getString('consec'),
    status: urlParams.getISelectArray('status')
  });

  const [totalLength, setTotalLength] = useState(0),
    [trucks, setTrucks] = useState(new Array<TruckData>()),
    [lastPage, setLastPage] = useState(1),
    [customers, setCustomers] = useState(new Array<ISelectOption>()),
    [managers, setManagers] = useState(new Array<ISelectOption>()),
    [statuses, setStatuses] = useState(new Array<ISelectOption>()),
    handleRefreshClick = () => {
      loadData()
    },
    handleNextPageClick = () => {
      if (settings.page < lastPage) {
        setSettings({ ...settings, page: settings.page + 1 })
      }
    },
    handlePrevPageClick = () => {
      if (settings.page > 1) {
        setSettings({ ...settings, page: settings.page - 1 })
      }
    },
    onRowsChange = (newRows: number) => {
      setSettings({ ...settings, page: 1, rows: newRows })
    };

  function sortBy(column: string): void {
    if (settings.sidx === column) {
      const newdir = (settings.sord === 'desc' ? 'asc' : 'desc')
      setSettings({ ...settings, sord: newdir })
    }
    else {
      setSettings({ ...settings, sidx: column })
    }
    handleRefreshClick();
  }

  function getSortIcon(column: string): string {
    if (column === settings.sidx) {
      return (settings.sord === 'desc' ? 'fa fa-sort-down' : 'fa fa-sort-up');
    }
    else {
      return 'fa fa-sort';
    }
  }

  function recalcLastPage(): void {
    setLastPage(Math.ceil(totalLength / settings.rows))
  }

  function loadFiltersData() {
    Axios({ url: `/trucks/fdata.json` })
      .then((res) => {
        setCustomers(res.data.customers)
        setManagers(res.data.managers)
        setStatuses(res.data.statuses)

      })
      .catch((err) => {
        console.log(err)
      })
  }

  function loadData() {
    let url_params = `rows=${settings.rows}&page=${settings.page}&sidx=${settings.sidx}&sord=${settings.sord}`;
    if (settings.customer) {
      url_params = `${url_params}&customer=${settings.customer.value},${settings.customer.label}`
    }
    if (settings.manager) {
      url_params = `${url_params}&manager=${settings.manager.value},${settings.manager.label}`
    }
    if (settings.status.length > 0) {
      const st_all = settings.status.map((st) => `${st.value},${st.label}`).join(":")
      url_params = `${url_params}&status=${st_all}`
    }
    if (`${settings.consec}`.length > 0) {
      url_params = `${url_params}&consec=${settings.consec}`
    }
    if (`${settings.query}`.length > 0) {
      url_params = `${url_params}&query=${settings.query}`
    }
    props.history.push(`${props.location.pathname}?${url_params}`)

    Axios({
      method: 'GET',
      url: `/trucks/data.json?${url_params}`,
      headers: {
        accept: 'application/json'
      }
    })
      .then((res) => {
        if (res.data.trucks.length > 0) {
          setTrucks(res.data.trucks)
          setTotalLength(res.data.records)
        } else {
          setTrucks([])
          setTotalLength(0)
        }

        // if (settings.page > 1 && settings.page > lastPage) {
        //   setSettings({ ...settings, page: 1 })
        // }

      })
      .catch((err) => {
        console.log(err)
      })
  }

  const handlePageClick = (event) => {
    setSettings({ ...settings, page: event.selected + 1 })
  }


  function searchByConsec(newVal: string) {
    if (settings.consec !== newVal) {
      setSettings({ ...settings, consec: newVal })
    }
  }

  function searchByQuery(newVal: string) {
    if (settings.query !== newVal) {
      setSettings({ ...settings, query: newVal })
    }
  }

  function visibleItems(): React.ReactNode[] {
    return trucks.map((n) => (
      <ListItem
        key={n.id}
        truck={n}
        onDestroyHandler={loadData}
      />
    ))
  }

  function handleCustomerChange(opt: ISelectOption): void {
    if (opt) {
      setSettings({ ...settings, customer: opt })
    } else {
      setSettings({ ...settings, customer: null })
    }
  }

  function handleManagerChange(opt: ISelectOption): void {
    if (opt) {
      setSettings({ ...settings, manager: opt })
    } else {
      setSettings({ ...settings, manager: null })
    }
  }

  function handleStatusChange(opt: ISelectOption[]): void {
    if (opt) {
      setSettings({ ...settings, status: opt })
    } else {
      setSettings({ ...settings, status: null })
    }
  }

  useEffect(() => {
    recalcLastPage()
  }, [totalLength, settings])


  useEffect(() => {
    loadData();
  }, [settings])

  useEffect(() => {
    loadFiltersData();
  }, [])

  return (
    <div className="wrapper wrapper-content">

      <div className="ibox-content m-b-sm border-bottom">
        <div className="row">
          <div className="col-lg-12 animated fadeInRight">
            <h2>Trucks ({totalLength})</h2>
          </div>
        </div>


        <div className="row">
          <div className="col-sm-2">
            <TextSearchField
              inputText={settings.query}
              placeholder={"Truck ID or name"}
              searchBy={searchByQuery} ></TextSearchField>
          </div>
          <div className="col-sm-1">
            <TextSearchField
              inputText={settings.consec}
              placeholder={"Cust. Truck Id"}
              searchBy={searchByConsec} ></TextSearchField>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <Select
                isClearable
                placeholder="Customer"
                options={customers}
                defaultValue={settings.customer}
                onChange={val => handleCustomerChange(val)}
              />
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              <Select
                isClearable
                placeholder="Sales manager"
                options={managers}
                defaultValue={settings.manager}
                onChange={val => handleManagerChange(val)}
              />
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <Select
                isMulti
                placeholder="Status"
                options={statuses}
                defaultValue={settings.status}
                onChange={val => handleStatusChange(val)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 animated fadeInRight">
            <Paging
              onRowsChange={onRowsChange}
              onNextClick={handleNextPageClick}
              onPrevClick={handlePrevPageClick}
              rows={settings.rows}
              page={settings.page}
              lastPage={lastPage}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 animated fadeInRight">
          <div className="mail-box">
            <table className="footable table table-hover table-mail footable-loaded ">
              <thead>
                <tr>
                  <th>#
                  </th>
                  <th className="mail-subject footable-visible footable-sortable" onClick={() => sortBy('consec_number')}>
                    Customer Truck ID
                    <span> &nbsp;&nbsp;&nbsp;
                      <i className={getSortIcon('consec_number')}></i>
                    </span>
                  </th>
                  <th>Customer</th>
                  <th>Country</th>
                  <th className="mail-subject footable-visible footable-sortable" onClick={() => sortBy('typ')}>
                    Truck Type
                    <span> &nbsp;&nbsp;&nbsp;
                      <i className={getSortIcon('typ')}></i>
                    </span>
                  </th>
                  <th>Payload % </th>
                  <th>Payload €</th>
                  {/* <th>Payload Status</th> */}
                  <th> Transport cost</th>
                  <th>Sales Manager</th>
                  <th>Status</th>
                  <th className="mail-date footable-visible footable-sortable" onClick={() => sortBy('dispatch_date')}>
                    Dispatch date &nbsp;&nbsp;&nbsp;
                    <span>
                      <i className={getSortIcon('dispatch_date')}></i>
                    </span>
                  </th>
                  <th className="mail-date footable-visible footable-sortable" onClick={() => sortBy('created_at')}>
                    Created_at &nbsp;&nbsp;&nbsp;
                    <span>
                      <i className={getSortIcon('created_at')}></i>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {visibleItems()}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={12} className="footable-visible">
                    <ReactPaginate id="react-paginate"
                      // labels

                      previousLabel={'Previous'}
                      nextLabel={'Next'}
                      breakLabel={'…'}

                      disabledClassName={'disabled'}

                      breakClassName={'page-item'}
                      breakLinkClassName={'page-link'}
                      containerClassName={'pagination pull-right'}
                      pageClassName={'page-item'}
                      pageLinkClassName={'page-link'}
                      previousClassName={'page-item'}
                      previousLinkClassName={'page-link'}
                      nextClassName={'page-item'}
                      nextLinkClassName={'page-link'}
                      activeClassName={'active'}

                      // functionality
                      initialPage={settings.page - 1}
                      pageCount={lastPage} //total pages
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      //   forcePage={5}
                      onPageChange={(event) => { handlePageClick(event) } /*Fxn when page clicked*/}
                      disableInitialCallback={true}
                    />

                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default List
